import { Component, inject } from '@angular/core';
import { LayoutService } from '../service/layout.service';

/**
 * Pied de page posé dans le plateau de contenu (grammaire Prodicee) :
 * marque + version à gauche, mention Cerema et logo institutionnel à droite.
 */
@Component({
    standalone: true,
    selector: '[app-footer]',
    template: `
        <div class="footer-start">
            <img [src]="layoutService.layoutConfig().logoUrl" alt="" class="footer-logo" />
            <span class="footer-app-name">{{ layoutService.layoutConfig().appName || 'Abonéo' }}</span>
            @if (layoutService.layoutConfig().appVersion; as version) {
                <span class="footer-version">v{{ version }}</span>
            }
        </div>
        <div class="footer-end">
            <span>Cerema © {{ year }}</span>
            <img src="assets/logo-cerema.svg" alt="Cerema" class="footer-cerema" />
        </div>
    `,
    host: {
        class: 'layout-footer',
    },
})
export class AppFooter {
    layoutService = inject(LayoutService);
    readonly year = new Date().getFullYear();
}
